export const GET_CHANGELOGS = 'GET_CHANGELOGS';
export const GET_CHANGELOG_BY_ID = 'GET_CHANGELOG_BY_ID';
export const UPDATE_CHANGELOG = 'UPDATE_CHANGELOG';
export const DELETE_CHANGELOG = 'DELETE_CHANGELOG';
export const CREATE_CHANGELOG = 'CREATE_CHANGELOG';
